import type { OperationType } from '@/core/infra_types'

export function formatOperationType(type: OperationType): string {
  return type
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}
